export default __webpack_public_path__ + "static/media/Quiver of Black Asps.b511eb29.jpg";